const INITIAL_STATE = {
    data: null
}

const EstabelecimentoLicenciadosReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'estabelecimentoLicenciados': {

            return {
                ...state,
                data: action.payload.estabelecimentoLicenciados,
                config: action.payload.config
            }
        }
        default: {
            return state
        }
    }
}

export default EstabelecimentoLicenciadosReducer
